import {
  FETCH_ACADEMIC_YEARS_REQUEST,
  FETCH_ACADEMIC_YEARS_SUCCESS, SET_ACTIVE_TERM
} from '../actions/academicyears'

const initialState = {
  items: [],
  activeTerm: null
}

export function academicyears (state = initialState, action) {
  switch (action.type) {
    case FETCH_ACADEMIC_YEARS_REQUEST:
      return Object.assign({}, state, {
        items: []
      })

    case FETCH_ACADEMIC_YEARS_SUCCESS:
      return Object.assign({}, state, {
        items: action.payload.academicYears
      })

    case SET_ACTIVE_TERM:
      return {
        ...state,
        activeTerm: action.payload.activeTerm
      }

    default:
      return state
  }
}

